import { Form, Modal } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAssignCommissionsSettingRank } from "../../../../../common/api/queries";
import HiddenInput from "../../../../../common/components/form/components/HiddenInput";
import { ModalSizes } from "../../../../../common/constants";
import { setErrorsToForm } from "../../../../../common/utils/formUtils";
import { validations } from "../../../../../common/utils/validationUtils";
import { CommissionsSettingsRankSelect } from "../../../../enumerations/components/form/CommissionsSettingsRankSelect";
import { AssignCommissionsSettingsRank, CommissionsSettings } from "../../types";

type Props = {
  isOpen: boolean;
  settings: CommissionsSettings;
  onFormCancel: VoidFunction;
};

export const CommissionsSettingsAssignRankModalForm = ({ isOpen, settings, onFormCancel }: Props) => {
  const { t } = useTranslation();

  const [form] = Form.useForm<AssignCommissionsSettingsRank>();

  const assignCommissionsSettingRank = useAssignCommissionsSettingRank();

  useEffect(() => {
    if (isOpen && settings) {
      form.setFieldsValue({ rankId: settings.rank?.id, optimisticLockVersion: settings.optimisticLockVersion });
    }
  }, [form, isOpen, settings]);

  const handleFormSubmit = () => {
    form.validateFields().then(values =>
      assignCommissionsSettingRank.mutate(
        {
          id: settings.agent.id,
          object: values
        },
        {
          onSuccess: onFormCancel,
          onError: error => setErrorsToForm(form, "commissions.settings.attrs", error.violations)
        }
      )
    );
  };

  return (
    <Modal
      width={ModalSizes.TINY}
      open={isOpen}
      title={t("commissions.settings.titles.agentRankAssign")}
      okText={t("common.save")}
      cancelText={t("common.cancel")}
      confirmLoading={assignCommissionsSettingRank.isPending}
      afterClose={() => form.resetFields()}
      onOk={handleFormSubmit}
      onCancel={onFormCancel}
      maskClosable={false}
    >
      <Form form={form} layout="vertical" name="commissionsSettingsAssignRankForm">
        <HiddenInput name="optimisticLockVersion" />

        <Form.Item name="rankId" label={t("commissions.settings.attrs.rankId")} rules={[validations.notNull]}>
          <CommissionsSettingsRankSelect />
        </Form.Item>
      </Form>
    </Modal>
  );
};
